<!--项目节能建议-->
<template>
    <div>
        <el-row style="margin-bottom: 15px;">
            <el-col :span="21">
                <el-input v-model="content" placeholder="节能建议内容" clearable></el-input>
            </el-col>
            <el-col :span="3" style="text-align: right">
                <el-button v-permission="['BUSINESS-SUGGEST-SAVEANDPUSH']" type="primary" size="medium" @click="saveSuggest">推送</el-button>
            </el-col>
        </el-row>
        <el-table border stripe :height="treeTableHeight" :data="tablelist" >
            <template v-for="(v,k) in columns">
                <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width"></el-table-column>
            </template>

        </el-table>
        <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
    </div>
</template>

<script>
import Pagination from '@/components/pagination'
import {addSuggest, suggestPage} from '@/api/suggest'
export default {
    name: '',
    components: {
        Pagination
    },
    props: {
        pid: {
            type: Number,
            default: null
        }
    },
    data(){
        return {
            tablelist: [],
            columns: [
                {
                    label: '订单编号',
                    prop: 'ordernum',
                    fixed: 'left',
                    width: '220px'
                },{
                    label: '创建时间',
                    prop: 'createTime',// template: 'installTime',
                    width: '150px'
                },{
                    label: '创建者手机号',
                    prop: 'mobile',
                    width: '120px'
                },{
                    label: '创建者昵称',
                    prop: 'nickName',
                    width: '100px'
                },{
                    label: '内容',
                    prop: 'content',
                    // width: '500px'
                }
            ],
            treeTableHeight: 650,
            queryInfo: {
                pagesize: 10,
                pagenum: 1
            },
            total: 0,
            content:''
        }
    },
    methods:{
        getHeight() {
            // this.objstyle.height = window.innerHeight - 170 -55 -40 + 'px'
            if(this.total>0){
                this.treeTableHeight = window.innerHeight - 60 -62 -62 -32 -220 + 'px'
            }else{
                this.treeTableHeight = window.innerHeight - 60 -62 -62 -220 + 'px'
            }
        },
        saveSuggest(){
            if(this.content!=''){
                let data={
                    content: this.content,
                    pid: this.pid
                }
                addSuggest(data).then(response => {
                    if(response.code!=200)  return this.$message.error(response.msg)
                    this.$message.success(response.msg)
                    this.init()
                })
            }else{
                this.$message.error('推送内容不能为空')
            }
        },
        init(){
            let param = {}
            param.current = this.queryInfo.pagenum
            param.size = this.queryInfo.pagesize
            suggestPage(param,this.pid).then(response => {
                if(response.code!=200)  return this.$message.error('获取节能建议'+response.msg)
                this.tablelist = response.data.records
                this.total = response.data.total
                this.getHeight()
            })
        },
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize
            this.init()
        },
        /**
         * 分页组件切换页事件处理
         * @param newPage
         */
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage
            this.init()
        }
    },
    created(){
        this.getHeight()
        this.init()
    }
}
</script>

<style scoped>

</style>
